// src/config/avatarConfig.ts

/**
 * Configuration for default avatars (illustrations).
 * These URLs point to pre-hosted images.
 * NOTE: The backend logic identifies these as "default" because they
 * do not start with the 'profiles/' path prefix used for custom uploads.
 * For a real application, you might use a more robust check,
 * or host them under a specific path like '/profiles/default/illustration-1.jpg'.
 */
export const defaultAvatarIllustrations: string[] = [
    '/assets/avatars/illustration-1.png',
    '/assets/avatars/illustration-2.png',
    '/assets/avatars/illustration-3.png',
    '/assets/avatars/illustration-4.png',
    '/assets/avatars/illustration-5.png',
    '/assets/avatars/illustration-6.png',
    '/assets/avatars/illustration-7.png',
    '/assets/avatars/illustration-8.png',
    // Add more default avatar URLs here
];

/**
 * The URL for the default avatar when a user removes their custom one.
 */
export const FALLBACK_DEFAULT_AVATAR_URL = '/assets/avatars/default-avatar.png';